import { STORE_IMMUTABLE_ALLERGENS } from "../actions";

export default function storeImmutableAllergens(state = [], action) {
  switch (action.type) {
    case STORE_IMMUTABLE_ALLERGENS:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/immutableAllergens.js